module.exports = __webpack_public_path__ + "assets/img/zoom_out_icon.966c7224.svg";